"use strict";

var WorkReportSummary = Backbone.Collection.extend({

    entity: 'WorkReport',

    comparator: function(model) { return -model.get('amount'); },

    url: function() {
        if (this.customUrl)
            return this.customUrl;

        // Build query from filter parameters
        var url;
        var params = { };

        if (this.filterParams.onlyInvoiced) params.invoiced = '';

        url = Core.contextRoot + '/workreport/summary' + (this.filterParams.path ? '/'+this.filterParams.path : '');
        if (this.filterParams.from == null || typeof this.filterParams.from == 'undefined') {
            var fromDate = new Date();
            fromDate.setHours(0,0,0,0);
            fromDate.setDate(1);
            this.filterParams.from = fromDate.getTime();
            if (!this.filterParams.to) {
                var toDate = fromDate;
                toDate.addMonths(1);
                this.filterParams.to = toDate.getTime();
            }
        }
        params.from = this.filterParams.from;
        if (this.filterParams.to)
            params.to = this.filterParams.to;
        var paramsStr = $.param(params);
        if (paramsStr.length > 0)
            url += '?' + paramsStr;
        return url;
    },

    initialize: function(models, options) {
        this.filterParams = options && options.filterParams || {};
    },

    combinedSummaryBy: function(attribute) {
        var combinedModels = [];
        var combinedModelByKey = {}
        this.each(function(model) {
            var key = model.get(attribute);
            if (attribute == "contractId" && !key) return; // exclude "None" row for contracts
            var combinedModel = combinedModelByKey[key];

            // Don't show absence related info in customers and customer projects
            if ((attribute == "customerId" || attribute == "customerProjectId") && model && model.get('type') == "ABSENCE") return true;
            if (!combinedModel) {
                combinedModel = model.clone();
                combinedModelByKey[key] = combinedModel;
                combinedModels.push(combinedModel);
                if (model.get('addOn')) {
                    combinedModel.set('addOnAmount', combinedModel.get('amount'));
                    combinedModel.set('addOnInvoicedAmount', combinedModel.get('invoicedAmount'));
                    combinedModel.set('amount', 0);
                    combinedModel.set('invoicedAmount', 0);
                }
            } else {
                _(Object.keys(combinedModel.attributes)).each(function (key) {
                    if (key == 'amount' || key == 'invoicedAmount' || key == 'totalPrice' || key == 'addOnAmount' || key == 'addOnInvoicedAmount') return;
                    if (combinedModel.get(key) != model.get(key))
                        combinedModel.set(key, null);
                }, this);
                var amount = model.get('amount');
                var invoicedAmount = model.get('invoicedAmount');
                var invoicedPrice = model.get('totalPrice');
                if (model.get('addOn')) {
                    if (amount) combinedModel.set('addOnAmount', combinedModel.get('addOnAmount') ? combinedModel.get('addOnAmount') + amount : amount);
                    if (invoicedAmount) combinedModel.set('addOnInvoicedAmount', combinedModel.get('addOnInvoicedAmount') ? combinedModel.get('addOnInvoicedAmount') + invoicedAmount : invoicedAmount);
                } else {
                    if (amount) combinedModel.set('amount', combinedModel.get('amount') ? combinedModel.get('amount') + amount : amount);
                    if (invoicedAmount) combinedModel.set('invoicedAmount', combinedModel.get('invoicedAmount') ? combinedModel.get('invoicedAmount') + invoicedAmount : invoicedAmount);
                }
                if (invoicedPrice == null) combinedModel.set('totalPrice', null);
                else if (invoicedPrice && combinedModel.get('totalPrice') !== null) combinedModel.set('totalPrice', combinedModel.get('totalPrice') ? combinedModel.get('totalPrice') + invoicedPrice : invoicedPrice);
                var cost = model.get('totalCost');
                if (cost == null) combinedModel.set('totalCost', null);
                else combinedModel.set('totalCost', combinedModel.get('totalCost') ? combinedModel.get('totalCost') + cost : cost);
            }
        }, this);
        return new WorkReportSummary(combinedModels);
    },

    subSummaryWhere: function(selection) {
        return new WorkReportSummary(this.where(selection));
    },

    sum: function(attribute, includeAddOn) {
        var sum = 0;
        this.each(function (entry) {
            if (!includeAddOn && entry.get('addOn')) return;
            sum += entry.get(attribute) ? entry.get(attribute) : 0;
        });
        return sum;
    },

    totalAmount: function() { return this.sum('amount'); },
    totalInvoicedAmount: function() { return this.sum('invoicedAmount'); },
    totalPrice: function() { return this.pluck('totalPrice').indexOf(null) < 0 ? this.sum('totalPrice') : undefined; },
    totalCount: function() { return this.sum('count'); },
    totalCost: function() { return this.sum('totalCost'); },
    currency: function() {
        var currencies = [];
        this.each(function (model) {
            if (model.get('currency') == null && model.get('groupId')) {
                var group = Core.client.groups.get(model.get('groupId'));
                currencies.push(group && group.get('defaultCurrency') || null);
            } else
                currencies.push(model.get('currency'));
        }, this);
        currencies = _(currencies).uniq();
        if (currencies.length == 1) return currencies[0];
    },
});

